// extracted by mini-css-extract-plugin
module.exports = {"root":"s5U66","controlButton":"_3EDMJ","controlButtonDisabled":"_3PzAJ","iconHolder":"_12xwV","button":"_1djSu","buttonLabel":"_3bsG9","icon":"QWewE"};